import { Operator } from '@jexop/core';
import { evaluate } from '../evaluator';

type MapTemplate = Record<string, unknown>;

const isExpression = (value: MapTemplate): boolean => typeof value.op === 'string';

export const mapOperator: Operator<unknown> = (props: Record<string, unknown>, ctx: object) => {
  const { array, value, as = 'item', body, map } = props as {
    array?: unknown;
    value?: unknown;
    as?: string;
    body?: unknown;
    map?: unknown;
  };

  const items = array ?? value;
  const template = body ?? map;

  if (!Array.isArray(items)) return [];
  const mapItems: unknown[] = items;
  if (!template || typeof template !== 'object' || Array.isArray(template)) {
    return null;
  }

  const mapTemplate = template as MapTemplate;

  return mapItems.map((item) => {
    const itemContext: Record<string, unknown> = { ...(ctx as Record<string, unknown>), [as]: item };

    if (isExpression(mapTemplate)) {
      return evaluate(mapTemplate, itemContext);
    }

    return Object.fromEntries(
      Object.entries(mapTemplate).map(([key, expression]) => [
        key,
        evaluate(expression, itemContext),
      ]),
    );
  });
};
